import PropTypes from "prop-types";
import csrfAxios from "@shared/csrfAxios";

const BrandedFeatureFlagTable = ({ brandedFeatureFlags, setBffs }) => {
  const deleteBff = (id) => {
    csrfAxios.delete(`/support/branded_feature_flags/${id}`).then((response) => {
      setBffs(response.data);
    });
  };

  const flags = brandedFeatureFlags.map((f) => (
    <tr key={`branded-feature-flag-${f.id}`}>
      <td>{f.id}</td>
      <td>{f.brand_name}</td>
      <td>{f.feature_name}</td>
      <td>
        <button type="button" onClick={() => deleteBff(f.id)}>
          Delete
        </button>
      </td>
    </tr>
  ));

  return (
    <table className="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Brand</th>
          <th>Feature</th>
          <th aria-label="Delete" />
        </tr>
      </thead>
      <tbody>{flags}</tbody>
    </table>
  );
};

BrandedFeatureFlagTable.propTypes = {
  brandedFeatureFlags: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setBffs: PropTypes.func.isRequired,
};

export default BrandedFeatureFlagTable;
